import * as actions from "./actionsTypes";
import RecidivismActionsServices from "./recidivism_actions.service";
import toastr from "toastr";
import messages from "../../messages";
import axios from "axios";

// Configuración de toastr
toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

// Obtener las reincidencias
export const getRecidivismActions = (filters) => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_RECIDIVISM_ACTIONS, payload: true });
    const response = await RecidivismActionsServices.getDataRecidivism(filters);
    dispatch({
      type: actions.GET_RECIDIVISM_ACTIONS,
      payload: {
        recidivismActions: response.data,
        recidivismActionsLength: response.data.count,
      },
    });
  } catch (error) {
    handleError(error, dispatch, actions.RECIDIVISM_ACTIONS_FAIL);
  } finally {
    dispatch({ type: actions.LOADING_RECIDIVISM_ACTIONS, payload: false });
  }
};

// Obtener las acciones disciplinarias
export const getRecidivismActionsDisciplinarias = (filters) => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_RECIDIVISM_ACTIONS, payload: true });
    const response = await RecidivismActionsServices.getDataRecidivismActions(filters);
    dispatch({
      type: actions.GET_RECIDIVISM_ACTIONS_DISCIPLINARIAS,
      payload: {
        recidivismActionsDisciplinarias: response.data,
      },
    });
  } catch (error) {
    handleError(error, dispatch, actions.RECIDIVISM_ACTIONS_FAIL);
  } finally {
    dispatch({ type: actions.LOADING_RECIDIVISM_ACTIONS, payload: false });
  }
};

// Obtener reincidencia de un empleado
export const getRecidivismEmployee = async (id) => {
  try {
    const response = await RecidivismActionsServices.getRecidivismEmployee(id);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};


// Manejo de errores
const handleError = (error, dispatch, actionType) => {
  let message = null;
  if (axios.isAxiosError(error)) {
    if (error.response?.status) {
      switch (error.response.status) {
        case 400:
          message = messages.errorMessage + " " + error.response.statusText;
          break;
        case 404:
          message = messages.errorMessage + " " + error.response.statusText;
          break;
        case 500:
          message = messages.errorMessage + " " + error.response.statusText;
          break;
        default:
          message = error.response.data;
          break;
      }
    } else {
      message =
        error.message === "Network Error"
          ? messages.networkError
          : error.message;
    }
  } else {
    message =
      error.message === "Network Error" ? messages.networkError : error.message;
  }
  dispatch({ type: actionType, payload: message });
};